import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";

export default function DivisionVendorFillRateGrid({ data = [] }) {
  const [isMobile] = useState(window.innerWidth <= 768);

  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "DivisionVendorFillRate_GridID_excelexport") {
      gridInstance.excelExport();
    }
  };

  const fillRateTemplate = (props) => {
    const rate = props.FillRate;
    const getColor = () => {
      if (rate >= 75) return { color: "#52c41a", bg: "#f6ffed", border: "#b7eb8f" };
      if (rate >= 40) return { color: "#faad14", bg: "#fffbe6", border: "#ffe58f" };
      return { color: "#ff4d4f", bg: "#fff1f0", border: "#ffccc7" };
    };
    const config = getColor();
    return (
      <div style={{ textAlign: "center" }}>
        <span
          style={{
            padding: "3px 10px",
            borderRadius: "12px",
            fontSize: "12px",
            fontWeight: "600",
            backgroundColor: config.bg,
            color: config.color,
            border: `1px solid ${config.border}`,
          }}
        >
          {rate != null ? `${rate}%` : "-"}
        </span>
      </div>
    );
  };

  return (
    <div
      className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
      style={{
        position: "relative",
        marginTop: "10px",
        background: "#fff",
        borderRadius: 12,
        boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
        padding: "6px",
        marginBottom: "20px",
      }}
    >
      <Row>
        <Col>
          <GridComponent
            ref={(g) => (gridInstance = g)}
            id="DivisionVendorFillRate_GridID"
            dataSource={data}
            allowPaging={true}
            allowSorting={true}
            allowFiltering={true}
            filterSettings={{ type: "Excel" }}
            toolbar={["ExcelExport", "Search"]}
            allowExcelExport={true}
            toolbarClick={toolbarClick}
            enableAdaptiveUI={isMobile}
            rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
            gridLines="Both"
            height={"350px"}
            pageSettings={{
              pageSizes: [10, 20, 30, 40, 50, "All"],
              pageCount: 10,
            }}
            dataBound={() => {
              if (gridInstance) gridInstance.autoFitColumns();
            }}
            rowHeight={isMobile ? "" : 34}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="serialNo"
                headerText="S No"
                width="90"
                textAlign="Center"
                isPrimaryKey={true}
                allowFiltering={false}
              />
              <ColumnDirective
                field="DivisionName"
                headerText="Division Name"
                width="250"
                textAlign="Left"
              />
              <ColumnDirective
                field="Vendor"
                headerText="Vendor"
                width="250"
                textAlign="Left"
              />
              <ColumnDirective
                field="OHValue"
                headerText="OH Value"
                width="200"
                textAlign="Right"
                format="N2"
              />
              <ColumnDirective
                field="POCRaised"
                headerText="PO Raised"
                width="200"
                textAlign="Right"
                format="N2"
              />
              <ColumnDirective
                field="DistinctReceiveItemCount"
                headerText="Distinct Receive Item Count"
                width="270"
                textAlign="Center"
              />
              <ColumnDirective
                field="FillRate"
                headerText="Fill Rate %"
                width="180"
                textAlign="Center"
                template={fillRateTemplate}
              />
            </ColumnsDirective>
            <Inject
              services={[Page, Filter, Toolbar, ExcelExport, Sort, Group, Resize, Freeze]}
            />
          </GridComponent>
        </Col>
      </Row>
    </div>
  );
}
